module.exports = "<pl-modules></pl-modules>\n"


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/settings/settings.component.html
// module id = ../../../../../src/app/settings/settings.component.html
// module chunks = main